/**
 * CalendarSettingsPage - Calendar Integration Settings
 * 
 * Settings for native calendar synchronization including:
 * - Auto-sync toggle
 * - Sync All Dates batch operation
 * - Category selection
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CalendarDays } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AppLogo from '@/components/AppLogo';
import CalendarSyncSettings from '@/components/Settings/CalendarSyncSettings';

const CalendarSettingsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-pink-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="p-2"
            data-testid="back-btn"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <AppLogo size="sm" showText={false} />
          <div className="flex-1">
            <h1 className="text-lg font-semibold text-slate-800">
              Calendar Integration
            </h1>
            <p className="text-xs text-slate-500">
              Sync dates to your phone calendar
            </p>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 py-6">
        <CalendarSyncSettings />
      </main>
    </div>
  );
};

export default CalendarSettingsPage;
